import React from "react";
import { Button, Modal } from "react-bootstrap";
import MeetConcierge from "./MeetConcierge";
import scss from './MeetConcierge.module.scss';

interface IMeetConciergeModalProps {
    show: boolean;
    isOnDashboard: boolean;
    handleClose: () => void;
    openPrefModal: () => void;
}

const MeetConciergeModal: React.FC<IMeetConciergeModalProps> = ({ show, isOnDashboard, handleClose, openPrefModal }) => {
    return (
        <Modal show={show} onHide={handleClose} dialogClassName={`${scss.modalLG} modal-dialog-scrollable`}>
            <Modal.Header closeButton={false} className="border-0 justify-content-end pb-0">
                <Button variant="link" className="text-shade" onClick={handleClose}>
                    Close <i className="fal fa-times fa-2xl text-primary ms-1"></i>
                </Button>
            </Modal.Header>
            <Modal.Body className={scss.modal}>
                <MeetConcierge isOnDashboard={isOnDashboard} openPrefModal={openPrefModal} />
            </Modal.Body>
        </Modal>
    )
}

export default MeetConciergeModal;